<script setup lang="ts">
import { hasSlotContent } from '../utils'
import type { LabelPosition } from './form-control'

interface Props {
  id?: string
  size?: 'xs' | 'sm' | 'md'
  disabled?: boolean
  labelPosition?: LabelPosition
  labelClass?: string
}

withDefaults(defineProps<Props>(), {
  size: 'sm',
  labelPosition: 'left',
})
</script>

<template>
  <div
    class="flex"
    :class="{
      'gap-x-2': hasSlotContent($slots.label),
      'flex-col': labelPosition === 'top',
    }"
    role="group"
  >
    <label
      v-if="hasSlotContent($slots.label)"
      class="flex items-center text-xs"
      :class="[
        {
          'text-neutral-dark-3': !disabled,
          'mb-0.5': size === 'xs',
          'text-neutral-dark-3/40': disabled,
          'text-right': labelPosition === 'left',
        },
        labelClass,
      ]"
      :for="id"
    >
      <slot name="label" />
    </label>
    <slot />
  </div>
</template>
